<template>
  <TarjetaDatos :titulo="titulo" tipo="naranja">
    <!--   <Campo2L :valor="recibo.ejercicio" etiqueta="Ejercicio"/>   
            <Campo2L :valor="recibo.numPoliza" etiqueta="Póliza"/> -->
    <Campo2L
      v-if="recibo.periodicidad"
      :valor="recibo.periodicidad"
      etiqueta="Periodicidad"
    />
    <Campo2L :valor="recibo.tipo" etiqueta="Tipo" />

    <Campo2L :valor="recibo.importeNeto | currencyEUR" etiqueta="Importe:" />
    <Campo2L :valor="recibo.estado" etiqueta="Estado:" />
    <Campo2L :valor="recibo.idRecibo" etiqueta="Identificador" />
    <Campo2L
      :valor="recibo.fecRecibo | dateDDMMYYYY"
      etiqueta="Fecha Recibo:"
    />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    recibo: {
      type: Object,
      required: true
    }
  },
  computed: {
    titulo() {
      if (!this.recibo.idRecibo) return "Cargando datos...";
      let fecha = this.$options.filters.dateDDMMYYYY(
        this.recibo.nsg("fecRecibo")
      );
      return `Recibo de fecha ${fecha}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
